import type { Resource } from '../../';
export const country_countries_TR: Resource = {"default":"Turkey"};
